<template>
  <div class="job-history-editor">
    <h4><b>{{name}}</b></h4>
    <p class="text-muted">{{description}}</p>
    <b-row
      v-for="(job, index) in jobHistory"
      :key="`${index}-job`"
      :class="{ 'border-top': index > 0, 'mt-2': index > 0, 'pt-3': index > 0 }"
    >
      <b-col :cols="index > 0 ? 10 : 12" :sm="index > 0 ? 11 : 12">
        <b-form-group label="Job Title">
          <b-form-input
            :value="job.jobTitle"
            @input="onJobTitleChange($event, index)"
            placeholder="Marketing Manager"
          />
        </b-form-group>
      </b-col>
      <b-col v-if="index > 0" cols="2" sm="1" class="d-flex justify-content-center pt-3">
        <span
          @click="onDeleteJob(index)"
          class="delete-button mt-4 pt-1"
        ><font-awesome-icon icon="trash-alt"/></span>
      </b-col>
      <b-col cols="12">
        <b-form-group label="Company Name">
          <b-form-input
            :value="job.companyTitle"
            @input="onCompanyNameChange($event, index)"
            placeholder="Great Western Railway"
          />
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="From">
          <date-picker
            :value="job.startDate"
            @input="onStartDateChange($event, index)"
            type="month"
            lang="en"
            format="MMM YYYY"
            input-class="mx-input mx-dimensions"
            confirm
          />
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="To">
          <date-picker
            :value="job.endDate"
            @input="onEndDateChange($event, index)"
            type="month"
            lang="en"
            format="MMM YYYY"
            input-class="mx-input mx-dimensions"
            confirm
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col>
        <span
          @click="onAddJob"
          :style="{ cursor: addJobHistoryButtonActive ? 'pointer' :  'default' }"
        >
          <b-button
            variant="primary"
            class="mr-1"
            style="line-height: 1.33"
            :disabled="!addJobHistoryButtonActive"
            pill
          >+</b-button>
          <b :class="{ 'text-muted': !addJobHistoryButtonActive }">Add another job</b>
        </span>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';

export default {
  name: 'JobTitleSelector',
  components: {
    Multiselect,
    DatePicker,
  },
  props: {
    name: {
      type: String,
    },
    description: {
      type: String,
    },
    value: {
      type: Array,
      default: () => [],
    }
  },
  data: () => ({
    fatalErr: null,
    err: null,
  }),
  computed: {
    jobHistory() {
      const defaultJobHistory = [ {
        jobTitle: '',
        companyTitle: '',
        startDate: null,
        endDate: null,
      } ];
      return Array.isArray(this.value) && this.value.length ? this.value : defaultJobHistory;
    },
    addJobHistoryButtonActive() {
      if (Array.isArray(this.value) && this.value.length) {
        return this.value.reduce((bool, { jobTitle, companyTitle, startDate }) => bool && jobTitle && companyTitle && startDate, true);
      }
      return false;
    },
  },
  methods: {
    onJobTitleChange(jobTitle, index) {
      const value = Array.isArray(this.value) ? this.value : [];
      if (value[index]) {
        value[index].jobTitle = jobTitle;
      } else {
        value.push({ jobTitle, companyTitle: '', startDate: '', endDate: '' });
      }
      this.$emit('input', value);
    },
    onCompanyNameChange(companyTitle, index) {
      const value = Array.isArray(this.value) ? this.value : [];
      if (value[index]) {
        value[index].companyTitle = companyTitle;
      } else {
        value.push({ jobTitle: '', companyTitle, startDate: '', endDate: '' });
      }
      this.$emit('input', value);
    },
    onStartDateChange(startDate, index) {
      const value = Array.isArray(this.value) ? this.value : [];
      if (value[index]) {
        value[index].startDate = startDate;
      } else {
        value.push({ jobTitle: '', companyTitle: '', startDate, endDate: '' });
      }
      this.$emit('input', value);
    },
    onEndDateChange(endDate, index) {
      const value = Array.isArray(this.value) ? this.value : [];
      if (value[index]) {
        value[index].endDate = endDate;
      } else {
        value.push({ jobTitle: '', companyTitle: '', startDate: '', endDate });
      }
      this.$emit('input', value);
    },
    onAddJob() {
      if (this.addJobHistoryButtonActive) {
        const value = this.value;
        value.push({ jobTitle: '', companyTitle: '', startDate: '', endDate: '' });
        this.$emit('input', value);
      }
    },
    onDeleteJob(index) {
      const value = this.value;
      value.splice(index, 1);
      this.$emit('input', value);
    }
  },
};
</script>

<style lang="scss">
.job-history-editor {
  .delete-button {
    color: #333;
    cursor: pointer;
    opacity: .75;

    &:hover {
      opacity: 1;
    }
  }
  .mx-datepicker {
    width: 100%;
    .mx-input {

      &.mx-dimensions {
        height: 38px;
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/profile/JobHistoryEditor.vue